<template>
	<div>
		<!-- <el-button type="primary" @click="is_show_search = true" plain>筛选内容</el-button> -->
		<!-- <el-button type="primary" @click="keySearch">搜索</el-button> -->
		<el-button type="primary" plain @click="resetSearch">刷新</el-button>
		<el-button type="primary" @click="handleCreate">添加</el-button>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="name" label="名称"> </el-table-column>
				<el-table-column prop="coin_name" label="币名"> </el-table-column>
				<el-table-column prop="exchange_rate" label="汇率(对合作商)"> </el-table-column>
				<el-table-column prop="commission_money" label="佣金(发货)"> </el-table-column>
				<el-table-column prop="commission_money_2" label="佣金(不发货)"> </el-table-column>
				<el-table-column label="状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state == 1 ? 'success' : 'danger'">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="设置时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" with="250">
					<template slot-scope="{row,$index}">
						<el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
						<!-- <el-popconfirm @confirm="handleDelete(row,$index)" @onConfirm="handleDelete(row,$index)" title="确定删除该数据？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm> -->
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row" @pagination="getList" />
			<!-- 搜索模态框 -->
			<el-dialog title="搜索" :visible.sync="is_show_search" width="40%">
				<span>
					<el-form ref="form" label-width="140px" size="medium">
						
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_search = false">返回</el-button>
					<el-button type="primary" @click="is_show_search = false;keySearch()">确定</el-button>
				</span>
			</el-dialog>
			<!-- 添加/编辑 -->
			<el-dialog title="设置" width="40%" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item label="名称">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.name" clearable> </el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="币名">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.coin_name" clearable> </el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="汇率(对合作商)">
							<el-col :span="12">
								<el-input-number v-model="create_data.exchange_rate" :precision="4" :step="1" :min="0.0000"></el-input-number>
							</el-col>
							<br>
							<span>这个数值是比如1元人民币等于多少元的外币</span>
						</el-form-item>
						<el-form-item label="佣金(发货)">
							<el-col :span="12">
								<el-input-number v-model="create_data.commission_money" :precision="2" :step="1" :min="0.00"></el-input-number>
							</el-col>
							<br>
							<span>需要仓库发货并签收</span>
						</el-form-item>
						<el-form-item label="佣金(不发货)">
							<el-col :span="12">
								<el-input-number v-model="create_data.commission_money_2" :precision="2" :step="1" :min="0.00"></el-input-number>
							</el-col>
							<br>
							<span>不需要仓库发货，但需要签收</span>
						</el-form-item>
						<el-form-item label="状态">
							<el-col :span="12">
								<el-switch v-model="create_data.state" :active-value='1' :inactive-value='0'></el-switch>
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="createData()">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		countrySet,countryList,countryDel
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				data_list: [], // 表格数据
				checkbox_data: [], // 多选的数组
				loading:true,
				is_show_create:false,
				dialogStatus:'',
				create_data:{}
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: [],
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			getList() { // 获取列表数据
				this.loading = true;
				countryList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			handleDelete(row, index) { // 数据的删除
				countryDel(Qs.stringify(row)).then(response => {
					this.data_list.splice(index, 1)
					this.$message({
						showClose: true,
						message: '删除成功',
						type: 'success'
					});
				})
			},
			
			resetCreateData() { // 重置create_data数据
				this.create_data = {
					'id': '',
					'name': '',
					'coin_name': '',
					'exchange_rate': 0.0000,
					'commission_money': 0,
					'commission_money_2': 0,
					'state': 1,
				}
			},
			handleCreate() {
				this.resetCreateData();
				this.is_show_create = !this.is_show_create;
			},
			handleUpdate(row) {
				this.create_data = Object.assign({}, row) // copy obj
				this.is_show_create = !this.is_show_create;
			},
			createData() {
				this.$store.commit('setAjaxLoading', true);
				countrySet(Qs.stringify(this.create_data)).then(response => {
					this.getList();
					this.is_show_create = !this.is_show_create;
					this.$message({
						showClose: true,
						message: '提交成功',
						type: 'success'
					});
				})
			},
		}
	}
</script>
